const en = {
  message: {
    mallHeader: {
      Trade: 'Swap',
      Meta: 'Meta',
      Explore: 'Market',
      Earn: 'Liquidity',
      Win:'Info',
      connect: 'Connect to Wallet',
      connectTitle: 'Connect to a wallet',
      connected: "Connected",
      disconnect: "Disconnect",
      Address: "Address",
      Balance: "Balance",
      learnMore: 'Learn more about wallets',
      notWallet: 'Haven’t got a crypto wallet yet?',
      Cooperate:'Cooperate',
      Guide:'Guide',
    },
    mallFooter: {
      desc: "Earlier this year, a mysterious force coming from another galaxy summoned the most influential people on planet Earth to a secret party. Acquiring one of them will give you access to an ever-growing community of investors and entrepreneurs.",
      company: "C O M P A N Y",
      help: "H E L P",
      connect: "C O N N E C T",
      emailUs: 'Email Us',
      fileDownload: "File download",
      guide: "Guide",
    },
    home: {
      title: 'Discover the Potential of Your Assets In Ouroboros Swap',
      startBigSwap: 'Start Big 5swap',
      liquidityProviders: 'FOR LIQUIDITY PROVIDERS',
      liquidityProvidersText1: 'Earn Passive Income with Your Crypto Assets',
      liquidityProvidersText2: 'Earn fees and rewards by depositing your tokens into our pools.',
      lowerSlippage: 'LOWER SLIPPAGE',
      lowerSlippageText1: 'Amplified Liquidity Pools',
      lowerSlippageText2: 'We can amplify liquidity pools to provide much higher capital efficiency and better slippage for you. Deposit less tokens and still achieve better liquidity and volume.',
      higherReturns: 'HIGHER RETURNS',
      higherReturnsText1: 'Dynamic Fees',
      higherReturnsText2: 'We adjust trading fees dynamically based on market conditions to give you the best returns.',
      bonusRewards: 'BONUS REWARDS',
      bonusRewardsText1: 'Rainmaker Yield Farming',
      bonusRewardsText2: 'Deposit your tokens and farm attractive rewards. We collaborate with projects to get you the best rewards.',
      forTraders: 'FOR TRADERS',
      forTradersText1: 'Swap your tokens at the best rates. No limits',
      forTradersText2: 'Through our dynamic trade routing technology, we aggregate liquidity from multiple exchanges, including Obsswap, and select the best trade route for you.',
      forTradersText3: 'No KYC or sign-ups required',
      forTradersText4: 'No extra deposit or withdrawal fees',
      forTradersText5: 'Supports permissionless listing',
      partners: 'Partners',
      partnersText: 'Creating the future of digital finance with Big ObsSwap',
      contactUs: 'Contact us',
      contactUsText: 'Establish strategic partnership with us',
    },
    trade: {
      swap: 'Swap',
      swapFrom: 'Swap from',
      swapTo: 'Swap to',
      balance: 'Balance',
      selectToken: 'Select a Token',
      enterAmount: 'Enter an Amount',
      price: 'Price',
      priceAmount: '{price} {symbolA} pre 1{symbolB}',
      minimumReceived: 'Minimum received',
      maximumSold: 'Maximum sold',
      priceImpact: 'Price Impact',
      liquidityProviderFee: 'Liquidity Provider Fee',
      minimumReceivedPrompt: 'Your transaction will recent if there is a large,unfavorable price movement before it is confirmed.',
      priceImpactPrompt: 'The difference between the market price and estimated price due to trade size.',
      liquidityProviderFeePrompt: 'A portion of each trade({fee}) goes to liquidity providers as a protocol incentive.',
      connectWallet: 'Connect Wallet',
      approve: "Approve",
      insufficientBalance: 'Insufficient balance',
      insufficientLiquidity: 'Insufficient liquidity',
      transactionSettings: 'Transaction Settings',
      slippageTolerance: 'Slippage Tolerance',
      slippageDealine: 'Slippage Dealine',
      minutes: 'minutes',
      interfaceSetting: 'Interface Setting',
      toggleExpertMode: 'Toggle Expert Mode',
      disableMultihops: 'Disable Multihops',
      slippageTolerancePrompt: 'Your transaction will revert if the price changes unfavorably by more than this percentage.',
      slippageDealinePrompt: 'Your transaction will revert if it is left confirming for longer than this time.',
      toggleExpertModePrompt: 'Bypasses confirmation modals and allows high slippage trades. Use at your own risk.',
      disableMultihopsPrompt: 'Restricts swaps to direct pairs only.',
      tips1: 'Enter a valid slippage percentage',
      tips2: 'Your transaction may fail',
      tips3: 'Your transaction may be frontrun',
      searchPlaceholder: 'Search name or paste address',
      import: 'Import',
      manage: 'Manage',
      importToken: 'Import Token',
      importTokenText1: 'Risk warning!',
      importTokenText2: 'Anyone can create a token,including creating fake version of existing tokens that claim to represent projects. If you purchase this token, you may not be able to sell it back',
      iUnderstand: 'I understand',
      confirmSwap: 'Confirm Swap',
      from: 'from',
      to: 'to',
      confirmSwapText: 'Output is estimated.You will receive at least {toInput} {symbol} or the transaction will revert',
      pendingTransaction: 'Pending Transaction',
      pendingTransactionText: 'Confirm this transaction in your wallet',
      pendingAddToken:'Add Big5-LP to Metamask',
      transactionSubmitted: 'Transaction Submitted',
      transactionFailed: 'Transaction Rejected',
      viewOnBscScan: 'View On IniverseScan',
      swapping: 'Swapping',
      adding: 'Adding',
      removing: 'Removing',
      for: 'for',
      and: 'and',
    },
    win: {
      title: '1000+ games coming soon',
      stayTuned: 'STAY TUNED',
      big5wap: 'Big 5wap',
    },
    earn: {
      liquidityProviderRewards: 'Liquidity provider rewards',
      yourLiquidity: 'Your Liquidity',
      createPair: 'Create a Pair',
      addLiquidity: 'Add Liquidity',
      noLiquidityFound: 'No liquidity found.',
      Earned: 'Earned',
      APR: 'APR',
      Liquidity: 'Liquidity',
      Add: 'Add',
      Remove: 'Remove',
      YourTotalPoolTokens: 'Your total pool tokens',
      Pooled: 'Pooled',
      YourPoolShare: 'Your pool share',
      addLiquidityTips: 'Tip:when you add liquidity,you will receive pool tokens representing your position.These tokens automatically earn fees proportional to your share of the pool,and can be redeemed at any time.',
      Input: 'Input',
      PriceAndPoolShare: 'Price and pool share',
      ShareOfPool: 'Share of Pool',
      Supply: 'Supply',
      removeLiquidity: 'Remove Liquidity',
      removeLiquidityTips: 'Tip:Removing pool tokens converse your position back into underlying tokens at the current rate,proportional to your share of the pool.Accrued fees are included in the amount you receive.',
      Amount: 'Amount',
      MAX: 'MAX',
      add: 'Add',
      remove: 'Remove',
      Confirm: 'Confirm',
      YouWillReceive:'You will Receive',
      WillReceiveTips:'Output is estimated.If the price changes by more than {slippage}% your transaction will revert.',
      Token:'Token',
      Burned:'Burned',
      Deposited:'Deposited',
      liquidityProviderRewardsPrompt:'liquidity providers earn a 0.3% fee on all trades proportional to their share of the pool.Fees are added to the pool,accrue in real time and can be claimed by withdrawing your liquidity.',
    },
    alertMsg: {
      MetaMaskPlugin: 'Please make sure your browser has installed the MetaMask plug-in',
      copySuccess: "Successful recovery",
      castCompletion: "casting completed",
      checkCreatorMsg: "Please go to the laboratory to check",
      bindSuperAddressMsg: "Please go to the laboratory to bind the superior",
      castFailureMsg: 'casting failed',
      harvestLPALADMsg: "The number of ALAD to be extracted is 0",
      harvestLPMsg: 'The number of LP to be extracted is 0',
      contentLPEmpty: 'Please enter the amount of pledged LP',
      insufficientBalance: 'Insufficient balance',
      stayTuned: 'Stay tuned',
    },
  }
}

export default en